export const tableConstants = {
  SET_SORTING_COLUMNS: 'SET_SORTING_COLUMNS',
};
